module.exports = __webpack_public_path__ + "img/10-half-sm.e22aef43.jpg";